import { Card, Fade, Grid, Icon, InputLabel, MenuItem, Modal, Select, Tooltip } from "@mui/material";
import SoftBox from "components/SoftBox";
import SoftButton from "components/SoftButton";
import SoftTypography from "components/SoftTypography";
import { useContext, useEffect, useRef, useState } from "react";
import { getUproColor } from "utils/colors";
import { gql, useMutation, useQuery } from "@apollo/client";
import { MessageManager } from "context";

const MEDIO_PAGO_DEFAULT = "1"; // Medio de pago: Transferencia

export default function ModalCargarPagoCC({ open, montoSugerido: _montoSugerido, usuario, token, refetchCC = () => { }, onClose, dataSedes }) {

    const { handleSnackbar } = useContext(MessageManager);
    const [selectedFile, setSelectedFile] = useState(null);
    const [fileError, setFileError] = useState("");
    //Sede seleccionada desde localStorage (si es que hay)
    const sedeSeleccionada = localStorage.getItem("idSede");
    const [idSede, setIdSede] = useState(null);
    useEffect(() => {
        if (sedeSeleccionada) {
            setIdSede(sedeSeleccionada);
        }
    }, []);
    const inputRef = useRef(null);

    const { data: mediosDePago } = useQuery(
        gql`
          query mediosDePagoModalCargarPagoCC {
            mediosDePago(filter: { online: true }) {
              id
              nombre
              cuotas
              cbu
              alias
              titular
            }
          }
        `, {
        skip: !open,
        cachePolicy: "no-cache",
        fetchPolicy: 'cache-and-network'
    }
    );

    const [savePago, { loading: savingPago }] = useMutation(
        gql`
          mutation savePagoCuentaCorriente($input: PagoCuentaCorrienteInput!) {
            savePagoCuentaCorriente(input: $input) {
              id
              cliente {
                id
                nombre
                apellido
              }
              total
              estado
            }
          }  
        `,
        {
            onError: (error) => {
                handleSnackbar(error.message, "error");
            }
        }
    )

    const handleInputFileChange = (e) => {
        if (e.target.files && e.target.files.length > 0) {
            const file = e.target.files[0];
            setSelectedFile(file);
            if (file.size > 5000000) {
                setFileError("El archivo debe pesar menos de 5MB");
                setSelectedFile(null);
            } else if (
                ![
                    "application/pdf",
                    "image/jpeg",
                    "image/jpg",
                    "image/png",
                ].includes(file.type)
            ) {
                setFileError("El archivo debe ser un PDF, JPG, JPEG o PNG");
                setSelectedFile(null);
            } else {
                setSelectedFile(file);
                setFileError("");
            }
        }
    };

    const handleRemoveFile = () => {
        setSelectedFile(null);
        setFileError("");
        if (inputRef.current) inputRef.current.value = "";
    };

    const handleCopy = (text) => {
        navigator.clipboard.writeText(text);
        handleSnackbar("Alias copiado al portapapeles", "success");
    };

    const handleSavePago = async () => {
        if (savingPago) {
            return;
        }
        if (!usuario?.id) {
            handleSnackbar("No se pudo obtener el usuario", "error");
            return;
        }
        if (!selectedFile) {
            handleSnackbar("Seleccione un comprobante", "warning");
            return;
        }

        const idClienteInput = Number(usuario?.cliente || usuario?.id) || null;
        let inputSave = {
            total: null,
            idSede: Number(idSede) || null,
            idCliente: idClienteInput,
            appUsuario: usuario?.sistema,
            file: selectedFile,
            token: token
        }

        try {
            await savePago({
                variables: {
                    input: inputSave
                }
            });
            handleSnackbar("Pago cargado correctamente", "success");
            onClose();
            setSelectedFile(null);
            setFileError("");
            refetchCC();
        } catch (error) {
            handleSnackbar(error.message, "error");
        }
    };

    return (
        <Modal
            aria-labelledby="transition-modal-title"
            aria-describedby="transition-modal-description"
            open={open}
            onClose={() => {
                if (savingPago) {
                    return;
                }
                onClose();
                setSelectedFile(null);
                setFileError("");
            }}
            closeAfterTransition
        >
            <Fade in={open}>
                <Card sx={{
                    position: "absolute",
                    top: "50%",
                    left: "50%",
                    transform: "translate(-50%, -50%)",
                    maxHeight: "90%",
                    width: { xs: "90%", sm: "25%" },
                    overflow: "auto",
                    p: 3,
                }}>
                    <SoftBox display="flex" justifyContent="space-between">
                        <SoftBox>
                            <SoftTypography variant="h6">Cargar pago</SoftTypography>
                        </SoftBox>
                        <SoftBox display="flex" justifyContent="space-between">
                            <SoftBox>
                                <Tooltip title="Cerrar" placement="top">
                                    <Icon fontSize="medium" onClick={() => {
                                        if (savingPago) {
                                            return;
                                        }
                                        onClose();
                                        setSelectedFile(null);
                                        setFileError("");
                                    }} sx={{ cursor: savingPago ? "default" : "pointer" }}>
                                        close
                                    </Icon>
                                </Tooltip>
                            </SoftBox>
                        </SoftBox>
                    </SoftBox>
                    <SoftBox>
                        <Grid container spacing={2}>
                            <Grid item xs={12}>
                                <SoftBox display="flex" flexDirection="column" gap={2} mt={2}>
                                    <SoftBox>
                                        <InputLabel htmlFor="modulo">
                                            <SoftTypography
                                                component="label"
                                                variant="caption"
                                                fontWeight="bold"
                                            >
                                                Alias
                                            </SoftTypography>
                                        </InputLabel>
                                        <SoftTypography variant="h6" fontWeight="bold" color="primary">
                                            {
                                                mediosDePago?.mediosDePago.find(
                                                    (medio) => medio?.id.toString() === MEDIO_PAGO_DEFAULT
                                                )?.alias
                                            }
                                        </SoftTypography>
                                    </SoftBox>
                                    {mediosDePago?.mediosDePago.find(
                                        (medio) => medio?.id.toString() === MEDIO_PAGO_DEFAULT
                                    )?.cbu && (
                                            <SoftBox>
                                                <InputLabel htmlFor="modulo">
                                                    <SoftTypography
                                                        component="label"
                                                        variant="caption"
                                                        fontWeight="bold"
                                                    >
                                                        CBU
                                                    </SoftTypography>
                                                </InputLabel>
                                                <SoftTypography variant="h6" fontWeight="bold" color="primary">
                                                    {
                                                        mediosDePago?.mediosDePago.find(
                                                            (medio) => medio?.id.toString() === MEDIO_PAGO_DEFAULT
                                                        ).cbu
                                                    }
                                                </SoftTypography>
                                            </SoftBox>
                                        )}
                                    <SoftBox>
                                        <InputLabel htmlFor="modulo">
                                            <SoftTypography
                                                component="label"
                                                variant="caption"
                                                fontWeight="bold"
                                            >
                                                Titular
                                            </SoftTypography>
                                        </InputLabel>
                                        <SoftTypography variant="h6" fontWeight="bold" color="primary">
                                            {
                                                mediosDePago?.mediosDePago.find(
                                                    (medio) => medio?.id.toString() === MEDIO_PAGO_DEFAULT
                                                )?.titular
                                            }
                                        </SoftTypography>
                                    </SoftBox>
                                    <SoftButton
                                        circular
                                        color="uproGreen"
                                        onClick={() =>
                                            handleCopy(
                                                mediosDePago?.mediosDePago.find(
                                                    (medio) => medio?.id.toString() === MEDIO_PAGO_DEFAULT
                                                ).alias
                                            )
                                        }
                                    >
                                        Copiar alias&nbsp;
                                        <Icon>content_copy</Icon>
                                    </SoftButton>
                                </SoftBox>
                            </Grid>

                            <Card>
                                <SoftBox p={2} display="flex" justifyContent="space-between" alignItems="center" flexWrap="wrap" gap={2}>
                                    <SoftBox display="flex" alignItems="center" gap={2}>
                                        <SoftBox>
                                            <SoftTypography variant="h6" fontWeight="bold">
                                                Sede seleccionada:
                                            </SoftTypography>
                                        </SoftBox>
                                    </SoftBox>
                                    <SoftBox
                                        sx={{
                                            minWidth: { xs: "100%", sm: "250px" },
                                            maxWidth: { xs: "100%", sm: "300px" }
                                        }}
                                    >
                                        <Select
                                            fullWidth
                                            value={idSede || ""}
                                            onChange={(e) => {
                                                const nuevaSede = e.target.value;
                                                setIdSede(nuevaSede);
                                            }}
                                            displayEmpty
                                            inputProps={{ "aria-label": "Sede" }}
                                            size="small"
                                        >
                                            <MenuItem value="" disabled>
                                                Seleccione una sede
                                            </MenuItem>
                                            {dataSedes?.sedesCuentaCorrienteInfo?.sedes?.map((sede) => (
                                                <MenuItem key={sede.id} value={sede.id}>
                                                    <SoftBox display="flex" alignItems="center" gap={1}>
                                                        <Icon fontSize="small" color="primary">
                                                            {sede.id === idSede ? "radio_button_checked" : "radio_button_unchecked"}
                                                        </Icon>
                                                        {sede.nombre}
                                                    </SoftBox>
                                                </MenuItem>
                                            ))}
                                        </Select>
                                    </SoftBox>
                                </SoftBox>
                            </Card>
                            <Grid item xs={12}>
                                <InputLabel htmlFor="comprobantePago">
                                    <SoftTypography variant="caption" fontWeight="bold">
                                        Comprobante de pago
                                        <SoftTypography variant="caption" fontWeight="bold" color="primary">
                                            &nbsp;*
                                        </SoftTypography>
                                    </SoftTypography>
                                </InputLabel>
                                <SoftBox
                                    sx={{
                                        border: selectedFile ? "2px solid #bdbdbd" : "2px dashed #bdbdbd",
                                        borderRadius: 2,
                                        p: 0,
                                        textAlign: "center",
                                        cursor: "pointer",
                                        mb: 2,
                                        backgroundColor: "#fafafa",
                                        transition: "border-color 0.2s",
                                        height: 180,
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        "&:hover": {
                                            borderColor: getUproColor("primary"),
                                        },
                                    }}
                                    onDragOver={e => {
                                        if (!selectedFile) {
                                            e.preventDefault();
                                            e.stopPropagation();
                                        }
                                    }}
                                    onDrop={e => {
                                        if (!selectedFile) {
                                            e.preventDefault();
                                            e.stopPropagation();
                                            if (e.dataTransfer.files && e.dataTransfer.files.length === 1) {
                                                const file = e.dataTransfer.files[0];
                                                if (file.size > 5000000) {
                                                    setFileError("El archivo debe pesar menos de 5MB");
                                                    setSelectedFile(null);
                                                } else if (
                                                    ![
                                                        "application/pdf",
                                                        "image/jpeg",
                                                        "image/jpg",
                                                        "image/png",
                                                    ].includes(file.type)
                                                ) {
                                                    setFileError("El archivo debe ser un PDF, JPG, JPEG o PNG");
                                                    setSelectedFile(null);
                                                } else {
                                                    setSelectedFile(file);
                                                    setFileError("");
                                                }
                                            }
                                        }
                                    }}
                                    onClick={e => {
                                        if (!selectedFile) {
                                            if (inputRef.current) inputRef.current.click();
                                        } else {
                                            const url = URL.createObjectURL(selectedFile);
                                            window.open(url, "_blank", "noopener,noreferrer");
                                            e.stopPropagation();
                                        }
                                    }}
                                >
                                    {!selectedFile ? (
                                        <SoftBox width="100%">
                                            <Icon sx={{ fontSize: 40, color: getUproColor("primary") }}>cloud_upload</Icon>
                                            <SoftTypography variant="body2" color="textSecondary">
                                                Hacé click para seleccionar el comprobante (PDF, JPG, PNG) o arrastrá el archivo aquí
                                            </SoftTypography>
                                        </SoftBox>
                                    ) : (
                                        <SoftBox
                                            sx={{
                                                width: "100%",
                                                height: "100%",
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "center",
                                                cursor: "pointer",
                                            }}
                                        >
                                            {selectedFile.type.startsWith("image/") ? (
                                                <img
                                                    src={URL.createObjectURL(selectedFile)}
                                                    alt="preview"
                                                    style={{
                                                        width: "auto",
                                                        height: "90%",
                                                        maxWidth: "100%",
                                                        objectFit: "contain",
                                                        borderRadius: 8,
                                                        boxShadow: "0 2px 8px rgba(0,0,0,0.08)"
                                                    }}
                                                />
                                            ) : (
                                                <Icon sx={{ fontSize: 60, color: getUproColor("primary") }}>picture_as_pdf</Icon>
                                            )}
                                        </SoftBox>
                                    )}
                                </SoftBox>
                                <input
                                    id="comprobantePagoInput"
                                    ref={inputRef}
                                    type="file"
                                    accept=".pdf,.jpg,.jpeg,.png"
                                    style={{ display: "none" }}
                                    onChange={handleInputFileChange}
                                    disabled={!!selectedFile}
                                />
                                <SoftBox display="flex" flexDirection="column" alignItems="stretch" gap={1} sx={{ mb: 1 }}>
                                    {selectedFile && (
                                        <>
                                            <SoftTypography
                                                variant="caption"
                                                color="primary"
                                                sx={{ wordBreak: "break-all", textAlign: "center", width: "100%" }}
                                            >
                                                {selectedFile.name}
                                            </SoftTypography>
                                            <SoftButton
                                                color="error"
                                                size="small"
                                                variant="outlined"
                                                disabled={savingPago}
                                                onClick={handleRemoveFile}
                                                sx={{ width: "100%" }}
                                            >
                                                <Icon sx={{ fontSize: 18, mr: 1 }}>delete</Icon>
                                                Quitar archivo
                                            </SoftButton>
                                        </>
                                    )}
                                    <SoftButton
                                        component="label"
                                        color="primary"
                                        circular
                                        sx={{ width: "100%" }}
                                        disabled={savingPago || !!selectedFile}
                                        onClick={() => {
                                            if (inputRef.current) inputRef.current.click();
                                        }}
                                    >
                                        <Icon sx={{ mr: 1 }}>upload_file</Icon> Seleccionar archivo
                                    </SoftButton>
                                </SoftBox>
                                {fileError && (
                                    <SoftTypography variant="caption" color="error">
                                        {fileError}
                                    </SoftTypography>
                                )}
                            </Grid>
                        </Grid>
                        <SoftBox mt={4} display="flex" justifyContent="center" alignItems="center">
                            <SoftBox mr={2}>
                                <SoftButton type="button" color="primary" fullWidth circular disabled={savingPago} onClick={() => {
                                    onClose();
                                    setSelectedFile(null);
                                    setFileError("");
                                }}>
                                    <Icon sx={{ fontWeight: "light" }}>close</Icon>
                                    &nbsp; Cancelar
                                </SoftButton>
                            </SoftBox>
                            <SoftBox>
                                <SoftButton
                                    type="button"
                                    color="uproGreen"
                                    fullWidth
                                    circular
                                    disabled={savingPago || !selectedFile || fileError || !idSede}
                                    onClick={handleSavePago}
                                >
                                    <div style={{ display: "flex", alignItems: "center" }}>
                                        {savingPago ? "Cargando..." : "Cargar pago"} &nbsp;
                                        <Icon sx={{ fontWeight: "light" }}>save</Icon>
                                    </div>
                                </SoftButton>
                            </SoftBox>
                        </SoftBox>
                    </SoftBox>
                </Card>
            </Fade>
        </Modal>
    );
}
